<template>
  <div class="form-container" :class="{is_open: isDropdownOpen}" v-click-away="() => {isDropdownOpen = false}">
    <!-- Search Input -->
    <div class="search-wrapper" @click="isDropdownOpen=!isDropdownOpen">
      <p class="placeholder" v-text="placeholderComp"></p>
    </div>

    <!-- Options List -->
    <div class="options-list">

      <div class="option-item" v-for="field in fields" :key="field.key">
        <span class="label" v-text="field.label"></span>
        <div class="counter-controls">
          <button @click="change(field.key, false)" class="counter-btn">-</button>
          <span class="count" v-text="field.value"></span>
          <button @click="change(field.key, true)" class="counter-btn">+</button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: ['fields', 'placeholder'],
  data() {
    return {
      searchQuery: '',
      isDropdownOpen: false
    }
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen
    },
    change(type, inc=true) {
        const item = this.fields.find(item => item.key === type)
        if (item) {
            if (inc) item.value++;
            else if (item.value > 0) item.value--;
        }
        this.$emit('change', this.fields)
    }
  },
  computed: {
    placeholderComp() {
      if(this.placeholder) return this.placeholder
      const allZero = this.fields.every(field => !field.value);
      return allZero ? 'לא ידוע' : this.fields.map(field => field.label + ' : ' + field.value).join(', ');
    }
  }
}
</script>

<style lang="scss" scoped>
// Variables
$primary-color: #333;
$border-color: #ddd;
$border-radius: 4px;
$spacing-unit: 8px;

.form-container {
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  position: relative;
  
  &.is_open {
    .options-list {
      display: block;
    }
  }
}

.search-wrapper { cursor: pointer;
  position: relative; border: solid 1px var(--border_color); display: flex; justify-content: space-between; align-items: center; padding-inline: 12px;
        border-radius: 12px; min-height: 40px;

     &::after { content: ''; background-position: center; background-size: contain; background-repeat: no-repeat;background-image: url('@/assets/arrow-bottom.svg'); width:12px; height: 8px; display: block; font-size: 10px; margin-right: 6px; }

    .placeholder {display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden; color: var(--hompage_text_blue) !important; font-size: 16px !important; }
  
  input {
    width: 100%;
    padding: $spacing-unit * 1.5;
        
    text-align: right;
    font-size: 1rem;
    outline: none;

    &:focus {
      border-color: darken($border-color, 15%);
      box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
    }
  }

  .dropdown-toggle {
    position: absolute;
    left: $spacing-unit;
    top: 50%;
    transform: translateY(-50%);
    border: none;
    background: none;
    cursor: pointer;
    padding: $spacing-unit;

    span {
      display: inline-block;
      transform: rotate(180deg);
    }
  }
}

.options-list {       z-index: 1;  border: solid 1px var(--border_color); border-radius: 12px; position: absolute; top: calc(100% + var(--gap_small)); left: 0; right: 0; background: white; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); display: none; 
  .option-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: $spacing-unit;
    margin-bottom: $spacing-unit;

    .label {
      font-size: 0.95rem;
      color: $primary-color;
    }

    .counter-controls {
      display: flex;
      align-items: center;
      gap: $spacing-unit * 1.5;

      .counter-btn {
        width: 24px;
        height: 24px;
        border: 1px solid $border-color;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: white;
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover {
          background: darken(white, 5%);
          border-color: darken($border-color, 10%);
        }

        &:active {
          transform: scale(0.95);
        }
      }

      .count {
        min-width: 20px;
        text-align: center;
        font-size: 0.95rem;
      }
    }
  }
}
</style>